module.exports = __webpack_public_path__ + "media/images/icons/icon-linkedin-8ffe52ad3bbd938440d2d8d3219c7c28.svg";